import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  API,
  NavigationHelper,
  DisplayActions,
  GlobalActions,
  TableLoops,
  viAdd,
  withRouter,
} from 'vibeguide';
import LoopSidebar from './Sidebar/LoopSidebar';
import SubNavigation from '../../Header/SubNavigation';
import './LoopsContainer.scss';

class LoopsContainer extends PureComponent {
  componentDidMount() {
    const qs = NavigationHelper.getParams() || {};
    const isNew = qs.type === 'new';
    const isView = qs.loopId && qs.type !== 'new';
    const isDuplicate = qs.loopId && qs.type === 'new';

    if (isNew || isView || isDuplicate) {
      setTimeout(() => {
        this.sidebar(qs.type, qs.loopId);
      }, 1500);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      location: {
        search,
      },
    } = this.props;

    const {
      location: {
        search: prevSearch,
      },
    } = prevProps;

    if (search !== prevSearch) {
      const qs = NavigationHelper.getParams();

      if (qs.loopId || qs.type === 'new') {
        this.sidebar(qs.type, qs.loopId);
      }
    }
  }

  showDisplayPlayer = async (e, messages) => {
    const {
      setDisplay,
    } = this.props;

    e.preventDefault();
    e.stopPropagation();

    setDisplay({
      show: true,
      messages,
      isLoop: true,
    });
  };

  showSidebarDisplayPlayer = async (messages) => {
    const {
      setDisplay,
    } = this.props;

    setDisplay({
      show: true,
      messages,
      isLoop: true,
    });
  };

  /**
   * When the sidebar is closed
   */
  onCloseSidebar = () => {
    const {
      history,
    } = this.props;

    const url = NavigationHelper.updateParams({
      loopId: null,
      type: null,
    }, {
      keepPage: true,
    });

    history(url);
  };

  sidebar = (type, loopId = null) => {
    const {
      setPanel,
    } = this.props;

    setPanel({
      show: true,
      backdrop: type === 'new',
      width: 600,
      children: (
        <LoopSidebar
          loopId={loopId}
          showDisplayPlayer={this.showSidebarDisplayPlayer}
          isNew={type === 'new'}
        />
      ),
      onClose: this.onCloseSidebar,
    });
  };

  render() {
    return (
      <div className="LoopsContainer">
        <SubNavigation
          title="Loops"
          buttons={[
            {
              text: 'New Loop',
              icon: viAdd,
              color: 'primary',
              url: NavigationHelper.updateParams({
                type: 'new',
              }),
              userCan: [
                'messagelist.create',
              ],
            },
          ]}
        />

        <TableLoops
          columns={[
            '.',
            'Name',
            'Description',
            'Company',
            'Duration',
            '# Of Locations',
            'Tags',
            '...',
          ]}
          fetch={API.Loops.list}
          defaultSortBy={{
            label: 'Name',
            attr: 'name',
            direction: 'asc',
          }}
          paginator
          paginatorProps={{
            label: 'Loops',
            urlPaging: true,
            urlFilters: true,
          }}
          toggle
          toggleProps={{
            label: 'Show Archived Loops',
            tooltip: true,
          }}
          bulk
          bulkProps={{
            edit: false,
            add: false,
            block: false,
            remove: false,
            archive: true,
          }}
          cardProps={{
            requireFilter: true,
          }}
          rowLink={{
            loopId: '_id',
          }}
          menuItems={[
            { name: 'Archive', userCan: 'messagelist.delete' },
          ]}
          showDisplayPlayer={this.showDisplayPlayer}
        />
      </div>
    );
  }
}

const mapDispatchToProps = {
  setPanel: GlobalActions.setPanel,
  setDisplay: DisplayActions.setDisplay,
};

export default withRouter(connect(null, mapDispatchToProps)(LoopsContainer));
